import { ChangeDetectionStrategy, Component, Input, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OptionsList } from 'src/app/models/optionsList.model';
import { Question } from 'src/app/models/question.model';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { filter, map } from 'rxjs';
import { AnswersStore } from 'src/app/store/answers-store';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Answer } from 'src/app/models/Answer.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';


@Component({
    selector: 'que-multi-question-display',
    imports: [CommonModule, ReactiveFormsModule, TranslateDirective, TranslatePipe],
    templateUrl: './multi-question-display.component.html',
    styleUrls: ['./multi-question-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiQuestionDisplayComponent implements OnInit {
  @Input()
  question?: Question;
  optionsListDetails?: OptionsList;
  @Input()
  isSub: boolean = false;
  @Input()
  isRequierd?: boolean;
  @Input() viewAnswer = false;

  myAnswer?: Answer;
  answer = new FormControl();
  #answerStore = inject(AnswersStore);

  #questionnaireStore = inject(QuestionnaireStore);
  isNotUser$ = this.#questionnaireStore.isUser$.pipe(map(x => !x));
  isDisableSignal$ = toSignal(this.isNotUser$)

  ngOnInit(): void {
    this.answer.setValidators(this.question?.requierd ? [Validators.required] : null);

    this.optionsListDetails = this.question?.optionsList;

    this.answer.valueChanges.subscribe(
      ans => {
        // var option=this.optionsListDetails?.answerOptionItem?.filter(op=>op.id==ans);
        this.#answerStore.updateAnswer({ id: 0, questionId: this.question?.id ?? 0, questionType: this.question?.type.id, multiOptionsAnswer: ans, isValid: this.answer.valid })
      });
    this.#answerStore.answers$.pipe(map(arr => arr.find(ans => ans.questionId == this.question?.id))).subscribe(x => {
      if (x) {
        this.myAnswer = x;
        this.answer.setValue(x.multiOptionsAnswer ?? null, { emitEvent: false });
      }
    }).unsubscribe();

  }
  chooseOption(guid: string) {
    var currentValue = this.answer.value as string;
    if (this.isExist(guid)) {
      const removeString = guid + ',';
      let newValue: string | null = currentValue.replace(removeString, '');
      if (newValue == ',') {
        newValue = null;
      }
      this.answer.setValue(newValue);
    } else {
      // If the ID doesn't exist, append it with a comma
      if (currentValue == '' || !currentValue)
        currentValue = ",";
      this.answer.setValue(currentValue + guid + ',');
    }
  }

  isExist(guid: string): boolean {
    const searchString = ',' + guid + ',';
    const currentValue = this.answer.value as string;
    if (currentValue == '')
      return false;
    // Check if the searchString is present in the currentValue
    return currentValue?.includes(searchString);
  }
  // gpt
  // chooseOption(id: number) {
  //   const currentValue = this.answer.value as string;
  //   if (!currentValue) {
  //     const newValue = currentValue + id + ',';
  //     this.answer.setValue(newValue);
  //   }
  //   const selectedIds = currentValue.split(',').filter(Boolean).map(Number);

  //   if (this.isExist2(id, selectedIds)) {
  //     const updatedIds = selectedIds.filter(existingId => existingId !== id);
  //     const newValue = updatedIds.join(',') + ',';
  //     this.answer.setValue(newValue);
  //   } else {
  //     const newValue = currentValue + id + ',';
  //     this.answer.setValue(newValue);
  //   }
  // }

  // isExist2(id: number, selectedIds: number[]): boolean {
  //   return selectedIds.includes(id);
  // }
  // isExist(id: number): boolean {
  //   const currentValue = this.answer.value as string;
  //   if (currentValue) {
  //     const selectedIds = currentValue.split(',').filter(Boolean).map(Number);
  //     return selectedIds.includes(id);
  //   }
  //   else return false;
  // }
}
